import {
    useRouteError,
} from 'react-router-dom'

import RouterErrorFallback from './RouterErrorFallback'

const RouterErrorBoundary = () => {
    const error = useRouteError()

    return <RouterErrorFallback error={error} />
}

export default RouterErrorBoundary
